/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CardCollapsable,
  FlexContainer,
  Label,
  InphiniteThemeColors,
  Tooltip,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { ocrGroupTitle } from '../../../state/constants';
import { CustomerIdTooltipContainer } from '../../Styles';
import { Banner } from '../banner';
import { CardContainer, CellContainer, NoInfo } from './Styles';

type Props = {
  data: any;
};

export const OcrDetail = ({ data }: Props) => {
  const { t } = useTranslation();
  const info = JSON.parse(data.dataSerialized);

  const errorCheck = !info['CHECKS']
    ? 'false'
    : Object.entries(info['CHECKS']).some(
        ([key, value], num) => value === false
      );
  const ocrInfo = {
    frontside: info?.FRONTSIDE || {},
    backside: info?.BACKSIDE || {},
    scoring: info?.SCORING || {},
    checks: info?.CHECKS || {},
  };
  const ocrBanner = `${data?.countryCode} - ${data?.docModel}`;

  const defineColor = (
    key: string,
    value: unknown
  ): InphiniteThemeColors | undefined => {
    if (typeof value !== 'boolean') return;
    return value ? 'success400' : 'error400';
  };

  const showValue = (value: string | boolean, isDate: boolean) => {
    if (typeof value === 'boolean') {
      return value ? 'OK' : 'KO';
    }
    if (Array.isArray(value)) return value.join(', ');
    return isDate ? value.replaceAll(' ', '/') : value;
  };

  const truncateString = (id: string): React.ReactNode => (
    <CustomerIdTooltipContainer>
      <Tooltip label={id} variant="secondary" place="top">
        <Label fontSize="14" semibold ellipsis>
          {id.substring(0, 30) + '...'}
        </Label>
      </Tooltip>
    </CustomerIdTooltipContainer>
  );

  const generateCardContent = (
    option: any,
    index: number,
    name: any,
    title: string = ''
  ): JSX.Element => (
    <CardContainer>
      {!option || Object.keys(option).length === 0 ? (
        <NoInfo>
          <Label>{t('There is not information')}</Label>
        </NoInfo>
      ) : (
        (!Array.isArray(option) ? [option] : option).map((item, count) => {
          return (
            <FlexContainer wrap="wrap" key={name + count}>
              {Object.entries(item).map(([key, value], num) => {
                return (
                  <CellContainer
                    key={name + count + num}
                    flex="0 0 calc(100%/3)"
                    alignItems="flex-start"
                  >
                    <Label>{t(key)}</Label>
                    {!key.includes('_SHA256') ? (
                      <Label semibold color={defineColor(key, value)}>
                        {
                          (value === null
                            ? '-'
                            : showValue(
                                value as any,
                                key.includes('_DATE')
                              )) as string
                        }
                      </Label>
                    ) : (
                      truncateString(value as string)
                    )}
                  </CellContainer>
                );
              })}
            </FlexContainer>
          );
        })
      )}
    </CardContainer>
  );

  return (
    <FlexContainer flexDirection="column" rowGap="1" style={{ height: '100%' }}>
      {Object.entries(info as any).length > 0 ? (
        <>
          <Banner title={ocrBanner} />
          {Object.entries(ocrInfo || {})?.map(([name, option], index) => {
            if (name === 'checks') {
              return (
                <CardCollapsable
                  withShadow
                  title={t(ocrGroupTitle[`${name}`])}
                  key={index}
                  isOpen={false}
                  iconLeft={
                    typeof errorCheck === 'string'
                      ? undefined
                      : errorCheck
                      ? 'XCircle'
                      : 'CheckCircle'
                  }
                  iconLeftColor={
                    typeof errorCheck === 'string'
                      ? undefined
                      : errorCheck
                      ? 'error400'
                      : 'success400'
                  }
                  iconLeftWeight="fill"
                >
                  {generateCardContent(option, index, name)}
                </CardCollapsable>
              );
            }

            let content = <></>;
            if (Object.keys(option).length > 2) {
              content = generateCardContent(option, index, name);
            } else {
              const optionList = Object.keys(option).map(
                (element, num) => option[element]
              );
              content = generateCardContent(optionList, index, name);
            }

            return (
              <CardCollapsable
                withShadow
                title={t(ocrGroupTitle[`${name}`])}
                key={index}
                isOpen={false}
              >
                {content}
              </CardCollapsable>
            );
          })}
        </>
      ) : null}
    </FlexContainer>
  );
};
